import { AGENT_PERMISSIONS } from './permissions-enum';

class PlayerPermissionsService {
  /**
   * Get specific permission
   * @param perm
   * @returns {boolean}
   */
  get(perm) {
    return APP_SETTINGS.player.permissions ? APP_SETTINGS.player.permissions.indexOf(perm) > -1 : false;
  }

  /**
   * Process permission rule on route change
   * set here all rules for page navigation
   * @param to
   */
  canPassPermissionCheck(to) {
    const currRouteName = to.name;
    switch (currRouteName) {
      case 'mybets':
        return this.get(AGENT_PERMISSIONS.CanViewQuickBetHistory);
    }
    return true;
  }
}

export default new PlayerPermissionsService();
